import { Component } from '@angular/core';

@Component({
  selector: 'app-quarantine-placement-footer',
  templateUrl: './quarantine-placement-footer.component.html',
  styleUrls: ['./quarantine-placement-footer.component.scss'],
  standalone: true
})
export class QuarantinePlacementFooterComponent {

}
